// データ表示用のフォーマッター関数

import type { DataValue, DataType } from '@/types/core.types';

/**
 * データ値をその型に応じてフォーマット
 * @param value データ値
 * @param dataType データ型
 * @returns フォーマットされた文字列
 */
export function formatDataValue(value: DataValue, dataType?: DataType): string {
  if (value === null || value === undefined) {
    return 'NULL';
  }

  switch (dataType) {
    case 'date':
      // YYYY-MM-DD形式のまま表示
      return String(value);
    
    case 'datetime':
      // ISO形式を読みやすい形式に変換（オプション）
      try {
        if (typeof value === 'string' || typeof value === 'number') {
          const date = new Date(value);
          if (!isNaN(date.getTime())) {
            return date.toLocaleString();
          }
        }
      } catch {
        // パースに失敗した場合はそのまま表示
      }
      return String(value);
    
    case 'float64': {
      // 大きな数値や小さな数値は指数表記
      const num = Number(value);
      if (!isNaN(num)) {
        if (Math.abs(num) >= 1e6 || (Math.abs(num) < 0.001 && num !== 0)) {
          return num.toExponential(3);
        }
        // 通常の数値は適切な桁数で表示
        return num.toString();
      }
      return String(value);
    }
    
    case 'boolean':
      // boolean型の場合、明示的にtrue/falseをチェック
      if (value === true) return 'true';
      if (value === false) return 'false';
      // 文字列として保存されている場合
      if (value === 'true' || value === 'True' || value === 'TRUE') return 'true';
      if (value === 'false' || value === 'False' || value === 'FALSE') return 'false';
      // 0や1などの数値をbooleanとして扱う場合
      if (value === 0 || value === '0') return 'false';
      if (value === 1 || value === '1') return 'true';
      // それ以外はNULL扱い
      return 'NULL';
    
    default:
      // dataTypeが指定されていない場合、値の型を見て判断
      if (typeof value === 'boolean') {
        return value ? 'true' : 'false';
      }
      return String(value);
  }
}